import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Force stale SW cleanup on fresh page load
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistration().then((reg) => {
    if (reg && reg.waiting) {
      reg.waiting.postMessage('skipWaiting');
    }
  }).catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
